import axios from 'axios';

const DEFAULT_TIMEOUT = 180000;

const resolvedTimeout = Number(process.env.REACT_APP_API_TIMEOUT) || DEFAULT_TIMEOUT;

// Create axios instance with base configuration
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000',
  timeout: resolvedTimeout,
  timeoutErrorMessage: `Request timed out after ${resolvedTimeout}ms. The server may be busy—please try again or narrow your filters.`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Required when backend CORS has credentials: true
});

// Request interceptor to add user information to all requests
api.interceptors.request.use(
  (config) => {
    // Get user data from localStorage
    const userData = localStorage.getItem('userData');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        if (user && user.username) {
          // Add user information to request headers
          config.headers['x-user-username'] = user.username;
          
          // Also add to request body for POST/PUT/PATCH requests if not already present
          if (['post', 'put', 'patch'].includes(config.method?.toLowerCase())) {
            if (config.data && typeof config.data === 'object') {
              // Add created_by if not already present
              if (!config.data.created_by) {
                config.data.created_by = user.username;
              }
              // Add updated_by for update operations
              if (['put', 'patch'].includes(config.method?.toLowerCase()) && !config.data.updated_by) {
                config.data.updated_by = user.username;
              }
            }
          }
        }
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
      }
    }
    
    // Log the request for debugging (optional)
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`, {
      headers: config.headers,
      data: config.data
    });
    
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    // Log successful responses for debugging (optional)
    console.log(`API Response: ${response.status} ${response.config.method?.toUpperCase()} ${response.config.url}`);
    return response;
  },
  (error) => {
    // Log error responses
    console.error('API Error:', {
      status: error.response?.status,
      message: error.response?.data?.message || error.message,
      url: error.config?.url,
      method: error.config?.method
    });
    
    // Handle specific error cases
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login
      localStorage.removeItem('userData');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default api; 